import React, { useEffect, useState } from "react";
import axios from "axios";

interface EditedBook {
  bookId: string;
  transcreated: boolean;
}

const MyEdits: React.FC = () => {
  const [transcreatedBooks, setTranscreatedBooks] = useState<EditedBook[]>([]);
  const [translatedBooks, setTranslatedBooks] = useState<EditedBook[]>([]);
  const [previews, setPreviews] = useState<{ [bookId: string]: string }>({});
  const userId = localStorage.getItem("userId");

  useEffect(() => {
    const fetchEditedBooks = async () => {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/my-edits/${userId}`
      );
      console.log(res);
      const books: EditedBook[] = res.data;

      const transcreated = books.filter((b) => b.transcreated);
      const translatedOnly = books.filter((b) => !b.transcreated);

      setTranscreatedBooks(transcreated);
      setTranslatedBooks(translatedOnly);

      //const allBookIds = books.map((b) => b.bookId);
      for (const book of books) {
        let id: string;
        id = book.bookId;
        const imgRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/get-book-preview/${id}?transcreated=${book.transcreated}`
        );
        if (book.transcreated) {
          id += "_1";
        }
        setPreviews((prev) => ({
          ...prev,
          [id]: `data:image/jpeg;base64,${imgRes.data}`,
        }));
      }
    };

    fetchEditedBooks();
  }, []);

  const handleDownload = async (bookId: string, transcreated: boolean) => {
    const url = `${process.env.REACT_APP_API_URL}/download-pdf/${bookId}?transcreated=${transcreated}`;
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = downloadUrl;
    a.download = transcreated
      ? `${bookId}_transcreated.pdf`
      : `${bookId}_translated.pdf`;
    a.click();
    a.remove();
  };

  const renderBooks = (books: EditedBook[]) => (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: "1rem",
        marginBottom: "2rem",
      }}
    >
      {books.map(({ bookId, transcreated }) => {
        const modifiedBookId = transcreated ? `${bookId}_1` : bookId;
        return (
          <div key={modifiedBookId} style={{ textAlign: "center" }}>
            <img
              src={previews[modifiedBookId]} // Use modifiedBookId here
              alt={`Preview of ${modifiedBookId}`} // And in the alt text
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "8px",
                border: "1px solid #ccc",
              }}
            />
            <button
              onClick={() => handleDownload(bookId, transcreated)}
              style={{
                marginTop: "0.5rem",
                padding: "0.4rem 0.6rem",
                fontSize: "0.85rem",
                cursor: "pointer",
              }}
            >
              Download
            </button>
          </div>
        );
      })}
    </div>
  );

  return (
    <div style={{ padding: "2rem" }}>
      <h2>Transcreated</h2>
      {renderBooks(transcreatedBooks)}

      <h2>Translated Only</h2>
      {renderBooks(translatedBooks)}
    </div>
  );
};

export default MyEdits;
